<template>
  <div id="content">
    <div class="container">
      <div class="center-block">
          <div class="col-md-10">
              <div class="main-timeline">
                  <div class="timeline">
                      <div class="timeline-content">
                          <div class="circle">
                            <span></span>
                            <img src="../assets/ceremony/church.png" class="church" />
                          </div>
                          <div class="content-inner">
                              <span class="year">15:00</span>
                              <h4 class="title text-uppercase" :class="smallerText"> {{ $t("ceremony.church.title") }} </h4>
                              <a href="https://www.google.com/maps/place/%E1%83%A0%E1%83%A3%E1%83%A1%E1%83%A3%E1%83%9A%E1%83%98+%E1%83%94%E1%83%99%E1%83%9A%E1%83%94%E1%83%A1%E1%83%98%E1%83%90,+T'bilisi,+G%C3%A9orgie/" target="_blank" style="display: block;">
                                <div class="description">
                                  <p> {{ $t("ceremony.church.name") }} </p>
                                  <p> {{ $t("ceremony.church.address") }} </p>
                                  <p> {{ $t("ceremony.church.city") }} </p>
                                  <span class="transparent visible-md-* visible-lg-*">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce non lectus justo.
                                  </span>
                                </div>
                              </a>
                              <div class="icon pull-right"><span></span></div>
                          </div>
                      </div>
                  </div>
                  <div class="timeline">
                      <div class="timeline-content">
                          <div class="circle">
                            <span></span>
                            <img src="../assets/ceremony/view.png" class="view" />
                          </div>
                          <div class="content-inner">
                              <span class="year">17:00</span>
                              <h4 class="title text-uppercase"> {{ $t("ceremony.view.title") }} </h4>
                              <a href="https://www.google.com/maps/place/The+Mtskheta+Church+of+Jvari+(Holy+Cross)/@41.8382032,44.7325854,19z/data=!4m12!1m6!3m5!1s0x40446f12f80be091:0xd6fd410dd15e161b!2sMonast%C3%A8re+de+Djvari!8m2!3d41.8381163!4d44.7331594!3m4!1s0x0:0x43eebc8d4b5224bd!8m2!3d41.8382459!4d44.7334449" target="_blank" style="display: block;">
                                <div class="description">
                                  <p> {{ $t("ceremony.view.name") }} </p>
                                  <p> {{ $t("ceremony.view.address") }} </p>
                                  <p> {{ $t("ceremony.view.city") }} </p>
                                  <span class="transparent visible-md-* visible-lg-*">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce non lectus justo.
                                  </span>
                                </div>
                              </a>
                              <div class="icon"><span></span></div>
                          </div>
                      </div>
                  </div>
                  <div class="timeline">
                      <div class="timeline-content">
                          <div class="circle">
                            <span></span>
                            <img src="../assets/ceremony/ring.png" class="ring" />
                          </div>
                          <div class="content-inner">
                              <span class="year">18:00</span>
                              <h4 class="title text-uppercase"> {{ $t("ceremony.entry.title") }} </h4>
                              <a
                                href="https://goo.gl/maps/XgznTwvB1a22"
                                target="_blank"
                                style="display: block;"
                              >
                                <div class="description">
                                  <p> {{ $t("ceremony.entry.name") }} </p>
                                  <p> {{ $t("ceremony.entry.address") }} </p>
                                  <p> {{ $t("ceremony.entry.city") }} </p>
                                  <span class="transparent visible-md-* visible-lg-*">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce non lectus justo.
                                  </span>
                                </div>
                              </a>
                              <div class="icon"><span></span></div>
                          </div>
                      </div>
                  </div>
                  <div class="timeline">
                      <div class="timeline-content">
                          <div class="circle">
                            <span></span>
                            <img src="../assets/ceremony/champagne.png" class="champagne" />
                          </div>
                          <div class="content-inner">
                              <span class="year">19:00</span>
                              <h4 class="title text-uppercase"> {{ $t("ceremony.dinner.title") }} </h4>
                              <a
                                href="https://goo.gl/maps/XgznTwvB1a22"
                                target="_blank"
                                style="display: block;">
                                <div class="description"
                              >
                                  <p> {{ $t("ceremony.dinner.name") }} </p>
                                  <p> {{ $t("ceremony.dinner.address") }} </p>
                                  <p> {{ $t("ceremony.dinner.city") }} </p>
                                  <span class="transparent visible-md-* visible-lg-*">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce non lectus justo.
                                  </span>
                                </div>
                              </a>
                              <div class="icon"><span></span></div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ceremony',
  data () {
    return {
      msg: ''
    }
  },
  computed: {
    smallerText: function () {
        return {'smaller-text': this.$i18n.locale === 'fr'}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$blue: #0176A6;
$green: darken(#08B387, 10);
$blue-dark: #013B53;

.smaller-text {
  font-size: 18px !important;
}

.transparent {
  opacity: 0;
}

.church {
  // background-image: url("../assets/ceremony/church.png");
  // background-position: center;
  //  position: relative;
  max-width: 80%;
  max-height: 84%;
}

.view {
  // background-image: url("../assets/ceremony/church.png");
  // background-position: center;
  //  position: relative;
  max-width: 80%;
  max-height: 80%;
}

.ring {
  // background-image: url("../assets/ceremony/church.png");
  // background-position: center;
  //  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.champagne {
  // background-image: url("../assets/ceremony/church.png");
  // background-position: center;
  //  position: relative;
  max-width: 80%;
  max-height: 94%;
}

.main-timeline{ position: relative; }
.main-timeline:before,
.main-timeline:after{
    content: "";
    display: block;
    width: 100%;
    clear: both;
}
.main-timeline:before{
    content: "";
    width: 3px;
    height: 100%;
    background: $blue;
    // background: url("../assets/ceremony/divider.png") no-repeat;
    // background-size: cover;
    // background-position: center;
    position: absolute;
    top: 0;
    left: 50%;
}
.main-timeline .timeline{
    width: 50%;
    float: left;
    position: relative;
    z-index: 1;
}
.main-timeline .timeline:before,
.main-timeline .timeline:after{
    content: "";
    display: block;
    width: 100%;
    clear: both;
}
.main-timeline .timeline:first-child:before,
.main-timeline .timeline:last-child:before{
    content: "";
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #f2f2f2;
    border: 4px solid $blue;
    position: absolute;
    top: 0;
    right: -14px;
    z-index: 1;
}
.main-timeline .timeline:last-child:before{
    top: auto;
    bottom: 0;
}
.main-timeline .timeline:last-child:nth-child(even):before{
    right: auto;
    left: -12px;
    bottom: -2px;
}
.main-timeline .timeline-content{
    text-align: center;
    margin-top: 8px;
    position: relative;
    transition: all 0.3s ease 0s;
    width: 100%;
}
.main-timeline .timeline-content:before{
    content: "";
    width: 100%;
    height: 5px;
    background: $blue;
    position: absolute;
    top: 88px;
    left: 0;
    z-index: -1;
}
.main-timeline .circle{
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: #fff;
    border: 8px solid $blue;
    float: left;
    margin-right: 25px;
    position: relative;
}
.main-timeline .circle:before{
    content: "";
    width: 26px;
    height: 30px;
    background: $blue;
    margin: auto;
    position: absolute;
    top: 0;
    right: -33px;
    bottom: 0;
    z-index: -1;
    box-shadow: inset 7px 0 9px -7px #444;
}
// .main-timeline .circle span{
//     display: block;
//     width: 100%;
//     height: 100%;
//     border-radius: 50%;
//     line-height: 160px;
//     // border: 3px solid $blue;
//     font-size: 80px;
//     color: #454344;
// }
.main-timeline .circle span:before,
.main-timeline .circle span:after{
    content: "";
    width: 28px;
    height: 50px;
    background: #f2f2f2;
    border-radius: 0 0 0 21px;
    margin: auto;
    position: absolute;
    top: -54px;
    right: -33px;
    bottom: 0;
    z-index: -1;
}
.main-timeline .circle span:after{
    border-radius: 21px 0 0 0;
    top: 0;
    bottom: -56px;
}
.main-timeline .content-inner{
    display: table;
    padding-right: 40px;
    position: relative;
}
.main-timeline .year{
    display: block;
    padding: 10px;
    margin: 10px 0 50px 0;
    background: $blue;
    border-radius: 7px;
    font-size: 25px;
    color: #fff;
}
.main-timeline .title{
    font-size: 20px;
    font-family: 'Agape';
    font-weight: bold;
    color: $green;
    margin-top: 0;
    white-space: nowrap;
}
.main-timeline .description{
    font-size: 18px;
    color: $blue-dark;
    text-align: center;
}
.main-timeline .icon{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #fff;
    border: 4px solid $blue;
    position: absolute;
    top: 78px;
    right: -14px;
}
.main-timeline .icon:before{
    content: "";
    width: 15px;
    height: 25px;
    background: $blue;
    margin: auto;
    position: absolute;
    top: -1px;
    left: -15px;
    bottom: 0;
    z-index: -1;
}
.main-timeline .icon span:before,
.main-timeline .icon span:after{
    content: "";
    width: 21px;
    height: 25px;
    background: #f2f2f2;
    border-radius: 0 0 21px 0;
    margin: auto;
    position: absolute;
    top: -30px;
    left: -15px;
    bottom: 0;
    z-index: -1;
}
.main-timeline .icon span:after{
    border-radius: 0 21px 0 0;
    top: 0;
    left: -15px;
    bottom: -30px;
}
.main-timeline .timeline:nth-child(2n) .timeline-content,
.main-timeline .timeline:nth-child(2n) .circle{
    float: right;
}
.main-timeline .timeline:nth-child(2n) .circle{
    margin: 0 0 0 25px;
}
.main-timeline .timeline:nth-child(2n) .circle:before{
    right: auto;
    left: -33px;
    box-shadow: -7px 0 9px -7px #444 inset;
}
.main-timeline .timeline:nth-child(2n) .circle span:before,
.main-timeline .timeline:nth-child(2n) .circle span:after{
    right: auto;
    left: -33px;
    border-radius: 0 0 21px 0;
}
.main-timeline .timeline:nth-child(2n) .circle span:after{
    border-radius: 0 21px 0 0;
}
.main-timeline .timeline:nth-child(2n) .content-inner{
    padding: 0 0 0 40px;
    margin-left: 2px;
}
.main-timeline .timeline:nth-child(2n) .icon{
    right: auto;
    left: -14px;
}
.main-timeline .timeline:nth-child(2n) .icon:before,
.main-timeline .timeline:nth-child(2n) .icon span:before,
.main-timeline .timeline:nth-child(2n) .icon span:after{
    left: auto;
    right: -15px;
}
.main-timeline .timeline:nth-child(2n) .icon span:before{
    border-radius: 0 0 0 21px;
}
.main-timeline .timeline:nth-child(2n) .icon span:after{
    border-radius: 21px 0 0 0;
}
.main-timeline .timeline:nth-child(2){
    margin-top: 180px;
}
.main-timeline .timeline:nth-child(odd){
    margin: -175px 0 0 0;
}
.main-timeline .timeline:nth-child(even){
    margin-bottom: 80px;
}
.main-timeline .timeline:first-child,
.main-timeline .timeline:last-child:nth-child(even){
    margin: 0;
}
@media only screen and (max-width: 990px){
    .main-timeline:before{ left: 100%; }
    .main-timeline .timeline{
        width: 100%;
        float: none;
        margin-bottom: 20px !important;
    }
    .main-timeline .timeline:first-child:before,
    .main-timeline .timeline:last-child:before{
        left: auto !important;
        right: -13px !important;
    }
    .main-timeline .timeline:nth-child(2n) .circle{
        float: left;
        margin: 0 25px 0 0;
    }
    .main-timeline .timeline:nth-child(2n) .circle:before{
        right: -33px;
        left: auto;
        box-shadow: 7px 0 9px -7px #444 inset;
    }
    .main-timeline .timeline:nth-child(2n) .circle span:before,
    .main-timeline .timeline:nth-child(2n) .circle span:after{
        right: -33px;
        left: auto;
        border-radius: 0 0 0 21px;
    }
    .main-timeline .timeline:nth-child(2n) .circle span:after{
        border-radius: 21px 0 0 0;
    }
    .main-timeline .timeline:nth-child(2n) .content-inner{
        padding: 0 40px 0 0;
        margin-left: 0;
    }
    .main-timeline .timeline:nth-child(2n) .icon{
        right: -14px;
        left: auto;
    }
    .main-timeline .timeline:nth-child(2n) .icon:before,
    .main-timeline .timeline:nth-child(2n) .icon span:before,
    .main-timeline .timeline:nth-child(2n) .icon span:after{
        left: -15px;
        right: auto;
    }
    .main-timeline .timeline:nth-child(2n) .icon span:before{
        border-radius: 0 0 21px 0;
    }
    .main-timeline .timeline:nth-child(2n) .icon span:after{
        border-radius: 0 21px 0 0;
    }
    .main-timeline .timeline:nth-child(2),
    .main-timeline .timeline:nth-child(odd),
    .main-timeline .timeline:nth-child(even){
        margin: 0;
    }
}
@media only screen and (max-width: 480px){
    .main-timeline:before{ left: 0; }
    .main-timeline .timeline:first-child:before,
    .main-timeline .timeline:last-child:before{
        left: -12px !important;
        right: auto !important;
    }
    .main-timeline .circle,
    .main-timeline .timeline:nth-child(2n) .circle{
        width: 130px;
        height: 130px;
        float: none;
        margin: 0 auto;
    }
    .main-timeline .timeline-content:before{
        width: 99.5%;
        top: 68px;
        left: 0.5%;
    }
    // .main-timeline .circle span{
    //     line-height: 115px;
    //     font-size: 60px;
    // }
    .main-timeline .circle:before,
    .main-timeline .circle span:before,
    .main-timeline .circle span:after,
    .main-timeline .icon{
        display: none;
    }
    .main-timeline .content-inner,
    .main-timeline .timeline:nth-child(2n) .content-inner{
        padding: 0 10px;
    }
    .main-timeline .year{
        margin-bottom: 15px;
    }
    .main-timeline .description{
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Ceremony.vue